<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-08 15:24:00
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="home-box">
    <div class="home-items">
      <div style="height: 0.3rem">
        <div style="font-size: 0.1rem; font-weight: 500">AI助手</div>
        <div>智能问答，日程管理，任务提醒，让工作更高</div>
      </div>
      <div class="card" style="width: 1.71rem; height: 3.78rem">
        <div class="card-header">快速功能</div>
        <div
          v-for="(item, index) in quickFuncList"
          :key="index"
          class="func-item"
          :class="getFuncBgClass(index)"
          @click="handleFuncClick(item)">
          <img :src="item.agentUrl || item.image || item.img || getDefaultIcon(index)" alt="">
          <div>
            <div>{{ item.agentName || item.name }}</div>
            <span>{{ item.agentDesc || item.description }}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="home-items">
      <div style="height: 0.3rem"></div>
      <div class="card" style="width: 3.63rem; height: 3.78rem;padding: 0;">
        <ChatPlugin v-if="selectedAgentId" ref="chatPlugin" :agentId="selectedAgentId"></ChatPlugin>
        <div v-else style="display: flex; align-items: center; justify-content: center; height: 100%; color: #999;">
          请先选择一个快速功能
        </div>
      </div>
    </div>
    <div class="home-items">
      <div style="height: 0.3rem"></div>

      <!-- <div class="card" style="width: 1.71rem; height: 1.06rem">
        <div class="card-header">今日概览</div>
        <div class="info">
          <div class="tips-4CA4F6">会议</div>
          <div>3个</div>
        </div>
        <div class="info">
          <div class="tips-42C094">任务</div>
          <div>8项</div>
        </div>
        <div class="info">
          <div class="tips-6B6CD9">提醒</div>
          <div>5条</div>
        </div>
        <div class="info">
          <div class="tips-E5A135">消息</div>
          <div>12条</div>
        </div>
      </div> -->
      <!-- <div class="card" style="width: 1.71rem; height: 1.58rem">
        <div class="card-header">智能建议</div>
        <div class="auto">
          <div class="title color-4CA4F6">会议提醒</div>
          <div class="text">下午2点有项目评审会议，请提前准备材料。</div>
        </div>
        <div class="auto">
          <div class="title color-42C094">任务建议</div>
          <div class="text">建议优先处理高优先级的客户反馈任务。</div>
        </div>
        <div class="auto">
          <div class="title color-E5A135">时间优化</div>
          <div class="text">今日工作负载较重，建议合理安排时间。</div>
        </div>
      </div> -->
      <div class="card" style="width: 1.71rem; height: 1.1rem">
        <div class="card-header">使用统计</div>
        <div class="info">
          <div>今日提问</div>
          <div class="color-E5A135">{{ statistics.todayQuestionCount || 0 }}次</div>
        </div>
        <div class="info">
          <div>解决问题</div>
          <div class="color-42C094">{{ statistics.solvedCount || 0 }}个</div>
        </div>
        <div class="info">
          <div>满意度</div>
          <div class="color-4CA4F6">{{ statistics.satisfactionRate || 0 }}%</div>
        </div>
        <div class="info">
          <div>节省时间</div>
          <div class="color-6B6CD9">{{ statistics.savedTime || 0 }}小时</div>
        </div>
      </div>
      <div class="card" style="width: 1.71rem; height: 2.6rem">
        <div class="card-header">常用问题</div>
        <div class="info" v-for="(item,index) in problemList" :key="index" @click="handleProblemClick(item)">
          <div class="tips">{{ item.title || item.question || item.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChatPlugin from '@/components/chat-plugin'
export default {
  name: 'center',
  components: { ChatPlugin },
  data () {
    return {
      problemList: [],
      quickFuncList: [],
      selectedAgentId: null, // 当前选中的 agentId
      statistics: {
        todayQuestionCount: 0, // 今日提问次数
        solvedCount: 0, // 解决问题数量
        satisfactionRate: 0, // 满意度
        savedTime: 0 // 节省时间（小时）
      }
    }
  },
  computed: {},
  created () {
    this.getProblemList()
    this.getQuickFuncList()
    // 从路由参数中获取 agentId
    if (this.$route.query.agentId) {
      this.selectedAgentId = this.$route.query.agentId
    }
    // 获取统计数据
    this.getStatistics()
  },
  watch: {
    // 监听路由参数变化
    '$route.query.agentId' (newVal) {
      if (newVal) {
        this.selectedAgentId = newVal
      }
    },
    // 监听 selectedAgentId 变化，重新获取常用问题列表和统计数据
    selectedAgentId (newVal) {
      if (newVal) {
        this.getProblemList()
        this.getStatistics()
      }
    }
  },
  methods: {
    // 获取快速功能列表
    getQuickFuncList () {
      this.$request.post('/sso/hiAgent/config/findList', {}).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 根据实际返回的数据结构调整，可能是 data.list 或 data.records 等
          this.quickFuncList = data.list || data.records || data || []
          // 如果列表不为空且还没有选中 agentId，默认选择第一个
          if (this.quickFuncList.length > 0 && !this.selectedAgentId) {
            const firstItem = this.quickFuncList[0]
            this.selectedAgentId = firstItem.id || firstItem.agentId || null
          }
        }
      }).catch(err => {
        console.error('获取快速功能列表失败:', err)
        this.quickFuncList = []
      })
    },
    // 获取功能项背景样式类
    getFuncBgClass (index) {
      const bgClasses = ['bg-DBEDFD', 'bg-D9F2EA', 'bg-E1E2F7', 'bg-FEE2DD']
      return bgClasses[index % bgClasses.length]
    },
    // 获取默认图标
    getDefaultIcon (index) {
      const icons = [
        require('../assets/images/common/richeng.png'),
        require('../assets/images/common/renwu.png'),
        require('../assets/images/common/zhishi.png'),
        require('../assets/images/common/shuju.png')
      ]
      return icons[index % icons.length]
    },
    // 点击功能项
    handleFuncClick (item) {
      // 获取 item 的 id 作为 agentId
      const agentId = item.id || item.agentId
      if (agentId) {
        this.selectedAgentId = agentId
        // agentId 变化会触发 ChatPlugin 中的 watch，自动重新获取配置和创建会话
      }
    },
    // 获取常用问题列表
    getProblemList () {
      const requestData = {
        pageNum: 1,
        pageSize: 10
      }
      // 如果有选中的 agentId，添加到请求参数中
      if (this.selectedAgentId) {
        requestData.agentId = this.selectedAgentId
      }
      this.$request.post('/sso/problem/findPageList', requestData).then(res => {
        const { code, data } = res.data
        if (code === 'OK') {
          // 根据实际返回的数据结构调整，可能是 data.list 或 data.records 等
          this.problemList = data.list || data.records || data || []
        }
      }).catch(err => {
        console.error('获取常用问题列表失败:', err)
        this.problemList = []
      })
    },
    // 点击常用问题，在 ChatPlugin 中发送消息
    handleProblemClick (item) {
      const questionText = item.title || item.question || item.name
      if (questionText && this.$refs.chatPlugin) {
        this.$refs.chatPlugin.sendQuickQuestion(questionText)
      }
    },
    // 获取使用统计数据
    getStatistics () {
      const requestData = {}
      // 如果有选中的 agentId，添加到请求参数中
      if (this.selectedAgentId) {
        requestData.agentId = this.selectedAgentId
      }
      this.$request.get('/sso/hiAgent/count/todayCount', requestData).then(res => {
        const { code, data } = res.data
        if (code === 'OK' && data) {
          // 根据实际返回的数据结构调整字段名
          this.statistics = {
            todayQuestionCount: data.todayQuestionCount || data.questionCount || data.todayCount || 0,
            solvedCount: data.solvedCount || data.solveCount || 0,
            satisfactionRate: data.satisfactionRate || data.satisfaction || 0,
            savedTime: data.savedTime || data.timeSaved || 0
          }
        }
      }).catch(err => {
        console.error('获取统计数据失败:', err)
        // 失败时保持默认值
        this.statistics = {
          todayQuestionCount: 0,
          solvedCount: 0,
          satisfactionRate: 0,
          savedTime: 0
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
@import url("./home/index.modules.less");
.bg-DBEDFD{
  background-color: #DBEDFD;
}
.color-4CA4F6{
  color: #4CA4F6;
}
.tips-4CA4F6 {
  padding-left: 16px;
  position: relative;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    background: #4CA4F6;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.bg-D9F2EA{
  background-color: #D9F2EA;
}
.color-42C094{
  color: #42C094;
}
.tips-42C094 {
  padding-left: 16px;
  position: relative;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    background: #42C094;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.bg-E1E2F7{
  background-color: #E1E2F7;
}
.color-6B6CD9{
  color: #6B6CD9;
}
.tips-6B6CD9 {
  padding-left: 16px;
  position: relative;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    background: #6B6CD9;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.bg-FEE2DD{
  background-color: #FEE2DD;
}
.color-E5A135{
  color: #E5A135;
}
.tips-E5A135 {
  padding-left: 16px;
  position: relative;

  &::before {
    content: '';
    width: 10px;
    height: 10px;
    background: #E5A135;
    border-radius: 5px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.card-header{
  margin-bottom: 6px;
}

.func-item{
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin-bottom: 12px;
  img{
    width: 44px;
    height: 44px;
    margin-right: 8px;
  }
  div{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    text-align: left;
    font-style: normal;
  }
  span{
    color: #666666;
    font-size: 14px;
    font-weight: 400;
  }
}
.auto{
  border-radius: 8px;
  border: 1px solid #F0F0F0;
  font-size: 14px;
  padding: 12px;
  margin-bottom: 12px;
  .title{
    font-weight: 500;
    margin-bottom: 4px;
  }
  .text{
    color: #666666;
    font-size: 13px;
  }
}
// 常用问题可点击样式
.card .info {
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    border-radius: 4px;
  }

  .tips {
    cursor: pointer;
    user-select: none;
  }
}
</style>
